import { useState } from "react";
import { Info } from "lucide-react";
import { Sheet } from "../ux/Sheet";

/**
 * A small ⓘ icon next to a profile section title. Tapping it opens a proper
 * explainer popup (the shared Sheet — slide-up on mobile, scale-in on desktop)
 * matching KikiHelpModal, rather than a cramped hover tooltip. Used to quietly
 * signal "this is public" without a wordy data-usage link.
 */
export function InfoTip({
  text,
  title = "Your public profile",
}: {
  text: string;
  title?: string;
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        aria-label={`About: ${title}`}
        onClick={() => setOpen(true)}
        className="p-0.5 text-neutral-400 hover:text-primary-500 transition-colors"
      >
        <Info className="w-[17px] h-[17px]" />
      </button>

      <Sheet open={open} onClose={() => setOpen(false)} hideHeader className="sm:max-w-sm">
        <div className="space-y-5">
          <div className="flex flex-col items-center text-center gap-3">
            <span className="w-12 h-12 rounded-full bg-primary-500/15 text-primary-500 flex items-center justify-center">
              <Info className="w-6 h-6" />
            </span>
            <h3 className="text-base font-semibold text-neutral-900 dark:text-white">{title}</h3>
          </div>

          <p className="text-sm text-neutral-600 dark:text-neutral-400 leading-relaxed text-center">
            {text}
          </p>

          <button type="button" onClick={() => setOpen(false)} className="btn btn-primary w-full">
            Got it
          </button>
        </div>
      </Sheet>
    </>
  );
}
